import { render } from "./ItemAdditionComponent.vue?vue&type=template&id=7f0d4533&scoped=true&ts=true"
import script from "./ItemAdditionComponent.vue?vue&type=script&lang=ts"
export * from "./ItemAdditionComponent.vue?vue&type=script&lang=ts"

import "./ItemAdditionComponent.vue?vue&type=style&index=0&id=7f0d4533&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f0d4533"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QSelect,QMenu,QIcon,QBtn});
